import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AqsnPropertyDetailsService {
  private selectedPropertyDetails: any;

  public AqsnPropertyDetailsServiceSub = new Subject<AqsnPropertyDetailsService>();

  constructor() { }

  public setSelectedPropertyDetails(selectedPropertyDetails: any) {
    this.selectedPropertyDetails = selectedPropertyDetails;
  }

  public getSelectedPropertyDetails() {
    return this.selectedPropertyDetails;
  }

  public notifySubscribers() {
    this.AqsnPropertyDetailsServiceSub.next(this.selectedPropertyDetails);
  }
}
